'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = LayoutDesktop;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./layout-desktop.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Layout Desktop Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function LayoutDesktop(props) {
    var _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    return (0, _jsx3.default)('main', {
        className: 'sb-layout-desktop',
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=LayoutDesktop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutDesktop/LayoutDesktop.js
// module id = 568
// module chunks = 0